import { ReactNode } from 'react';
import { Tooltip } from '@client/new/components/basic';
import { rgb } from '@design-system/tokens';
import coverImageInfo from '/static/images/cover-image-info.png';
import * as styles from './CoverImageTooltip.css';

const TooltipContent = () => (
  <div className={styles.content}>
    <div className={styles.text}>
      <div className={styles.title}>Cover image</div>
      <div>
        Displayed in Discovery and Carousel. Create motivating and engaging
        content to capture your audience's attention. Enhance your cover images
        with{' '}
        <a
          href="https://www.canva.com/design/DAEpjB3PXY4/xtlpMvdXkcbqVNS9MZJzww/view?utm_content=DAEpjB3PXY4&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          Canva templates
        </a>
        .
      </div>
    </div>
    <div className={styles.imageWrap}>
      <img src={coverImageInfo} className={styles.image} alt="" />
    </div>
  </div>
);

export const CoverImageTooltip = ({ children }: { children: ReactNode }) => (
  <Tooltip
    title={<TooltipContent />}
    placement="right-start"
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: rgb('N-100'),
          color: rgb('W-100'),
          fontSize: '14px',
          fontFamily: 'inherit',
          borderRadius: '10px',
          width: 'max-content',
          maxWidth: 'unset',
          p: 0,
        },
      },
    }}
  >
    <span>{children}</span>
  </Tooltip>
);
